export const SET_IS_LOADING = 'COMISSIONED_PAYROLL_LIST/SET_IS_LOADING';
export const SET_COMISSIONED_PAYROLL_LIST = 'COMISSIONED_PAYROLL_LIST/SET_COMISSIONED_PAYROLL_LIST';
export const CLEAR_COMISSIONED_PAYROLL_LIST = 'COMISSIONED_PAYROLL_LIST/CLEAR_COMISSIONED_PAYROLL_LIST';